import React from 'react';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { STooltip, SIcon } from '@avalara/skylab-sdk/react';

const log = new Logger('HELP_TEXT_FORM', LOG_LEVELS.ERROR);

export const HelpText = (props) => {
    log.debug('HelpText(): ', props);
    const { id, helpText = '' } = props;
    const tooltipId = `${id}-tooltip`;
    return (
      <span>
          <SIcon id={id} className="ml10" name="help-circle" role="img" aria-label="help" />
          <STooltip triggerId={id} tooltipId={tooltipId}>
          <span slot="content">{helpText}</span>
          </STooltip>
      </span>
    );
  }

  export default HelpText;
